/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type SaveChartInput = {
  athenaExecutionId: string,
  chartId: string,
  chartImageUrl?: string | null,
  chartType: ChartType,
  config?: string | null,
  createdAt?: string | null,
  createdBy?: string | null,
  dashboardIds?: Array< string > | null,
  description?: string | null,
  executionId?: string | null,
  lastModifiedAt?: string | null,
  lastModifiedBy?: string | null,
  name?: string | null,
  orgId: string,
  queryId: string,
};

export enum ChartType {
  BAR = "BAR",
  GEO = "GEO",
  LINE = "LINE",
  PIE = "PIE",
  SCATTER = "SCATTER",
}


export type ChartMetadata = {
  __typename: "ChartMetadata",
  athenaExecutionId?: string | null,
  chartId: string,
  chartImageUrl?: string | null,
  chartType: ChartType,
  config?: string | null,
  createdAt?: string | null,
  createdBy?: string | null,
  dashboardIds?: Array< string > | null,
  description?: string | null,
  executionId?: string | null,
  lastModifiedAt?: string | null,
  lastModifiedBy?: string | null,
  name?: string | null,
  orgId: string,
  queryId?: string | null,
};

export type SaveDashboardInput = {
  chartIds?: Array< string > | null,
  createdBy?: string | null,
  dashboardId: string,
  dashboardImageUrl?: string | null,
  description?: string | null,
  lastModifiedBy?: string | null,
  layout?: string | null,
  name?: string | null,
  orgId: string,
};

export type DashboardMetadata = {
  __typename: "DashboardMetadata",
  chartIds?: Array< string > | null,
  createdAt?: string | null,
  createdBy?: string | null,
  dashboardId: string,
  dashboardImageUrl?: string | null,
  description?: string | null,
  lastModifiedAt?: string | null,
  lastModifiedBy?: string | null,
  name?: string | null,
  orgId: string,
};

export type CreateNotificationInput = {
  createdAt?: string | null,
  createdBy?: string | null,
  isRead?: string | null,
  notificationId?: string | null,
  orgId?: string | null,
  payload?: string | null,
  readAt?: string | null,
  username?: string | null,
};

export type Notification = {
  __typename: "Notification",
  createdAt: string,
  createdBy: string,
  isRead?: string | null,
  notificationId: string,
  orgId: string,
  payload?: string | null,
  readAt?: string | null,
  readBy?: string | null,
  username: string,
};

export type CreateQueryTemplateInput = {
  createdBy?: string | null,
  description?: string | null,
  excludeOrgs?: Array< string > | null,
  filters?: Array< CreateTemplateFilterInput > | null,
  name: string,
  orgs?: Array< string > | null,
  query: string,
  templateKey?: string | null,
};

export type CreateTemplateFilterInput = {
  dependent?: boolean | null,
  displayName?: string | null,
  name: string,
  parentFilterName?: string | null,
  valueSource?: FilterValueSource | null,
  values?: string | null,
};

export type FilterValueSource = {
  column?: string | null,
  database?: string | null,
  orgColumn?: string | null,
  table?: string | null,
};

export type CreateQueryTemplateResponse = {
  __typename: "CreateQueryTemplateResponse",
  created?:  Array<CreatedQueryTemplateReference > | null,
  error?: string | null,
  failed?:  Array<FailedQueryTemplateReference > | null,
  message?: string | null,
  templateKey: string,
};

export type CreatedQueryTemplateReference = {
  __typename: "CreatedQueryTemplateReference",
  orgId: string,
  templateId: string,
};

export type FailedQueryTemplateReference = {
  __typename: "FailedQueryTemplateReference",
  orgId: string,
  reason: string,
};

export type CreateUserInput = {
  email: string,
  firstName: string,
  lastName: string,
  oktaUserId?: string | null,
  orgId: string,
  role: string,
};

export type UserResponse = {
  __typename: "UserResponse",
  message?: string | null,
  success?: boolean | null,
};

export type DeleteChartOrDashboardInput = {
  entityId: string,
  entityType?: EntityType | null,
  orgId: string,
};

export enum EntityType {
  CHART = "CHART",
  DASHBOARD = "DASHBOARD",
}


export type DeleteResponse = {
  __typename: "DeleteResponse",
  message?: string | null,
  statusCode?: number | null,
};

export type DeleteHistoryInput = {
  athenaExecutionId?: string | null,
  executionId?: string | null,
  executionSource?: ExecutionSource | null,
  orgId: string,
  queryId?: string | null,
};

export enum ExecutionSource {
  SCHEDULER = "SCHEDULER",
  SEGMENT = "SEGMENT",
  WORKBENCH = "WORKBENCH",
}


export type DeleteHistoryResponse = {
  __typename: "DeleteHistoryResponse",
  message?: string | null,
  statusCode?: number | null,
};

export type DeleteNotificationInput = {
  notificationId: string,
  orgId: string,
  username: string,
};

export type DeleteNotificationResponse = {
  __typename: "DeleteNotificationResponse",
  message?: string | null,
  statusCode?: number | null,
};

export type DeleteScheduleInput = {
  deletionType: string,
  orgId: string,
  schedulerId: string,
};

export type DeleteScheduleResponse = {
  __typename: "DeleteScheduleResponse",
  message?: string | null,
  schedulerId: string,
  success: boolean,
  successCode?: number | null,
};

export type QueryValidationNotifyInput = {
  athenaExecutionId?: string | null,
  createdAt?: string | null,
  createdBy?: string | null,
  executionDuration?: string | null,
  executionId?: string | null,
  executionSource?: ExecutionSource | null,
  executionStatus?: ExecutionStatus | null,
  lastModifiedAt?: string | null,
  lastModifiedBy?: string | null,
  orgId: string,
  query?: string | null,
  queryDescription?: string | null,
  queryId?: string | null,
  queryName?: string | null,
  segmentedFanCount?: string | null,
  status?: QueryStatus | null,
  validationLogs?: string | null,
  validationStatus?: ValidationStatus | null,
};

export enum ExecutionStatus {
  FAIL = "FAIL",
  IN_PROGRESS = "IN_PROGRESS",
  SUCCESS = "SUCCESS",
}


export enum QueryStatus {
  DRAFT = "DRAFT",
  EXECUTED = "EXECUTED",
  FAILED = "FAILED",
  IN_PROGRESS = "IN_PROGRESS",
  VALIDATED = "VALIDATED",
  VALIDATION_FAILED = "VALIDATION_FAILED",
}


export enum ValidationStatus {
  FAIL = "FAIL",
  IN_PROGRESS = "IN_PROGRESS",
  SUCCESS = "SUCCESS",
}


export type QueryValidationRecord = {
  __typename: "QueryValidationRecord",
  athenaExecutionId?: string | null,
  createdAt?: string | null,
  createdBy?: string | null,
  executionDuration?: string | null,
  executionId?: string | null,
  executionSource?: ExecutionSource | null,
  executionStatus?: ExecutionStatus | null,
  lastModifiedAt?: string | null,
  lastModifiedBy?: string | null,
  orgId: string,
  query?: string | null,
  queryDescription?: string | null,
  queryId?: string | null,
  queryName?: string | null,
  segmentedFanCount?: string | null,
  status?: QueryStatus | null,
  validationLogs?: string | null,
  validationStatus?: ValidationStatus | null,
};

export type UpdateScheduleStatusInput = {
  lastModifiedBy: string,
  orgId: string,
  schedulerId: string,
  status: SchedulerStatus,
};

export enum SchedulerStatus {
  ACTIVE = "ACTIVE",
  EXPIRED = "EXPIRED",
  PAUSED = "PAUSED",
}


export type QuerySchedulers = {
  __typename: "QuerySchedulers",
  createdAt?: string | null,
  createdBy?: string | null,
  end?: ScheduleEndType | null,
  lastModifiedAt?: string | null,
  lastModifiedBy?: string | null,
  name: string,
  orgId: string,
  queryId: string,
  queryName?: string | null,
  queryType?: QueryType | null,
  recurrence?: RecurrenceType | null,
  schedulerDescription?: string | null,
  schedulerId: string,
  schedulerStatus?: SchedulerStatus | null,
  startAt?: string | null,
  timezone?: string | null,
  type?: ScheduleType | null,
};

export type ScheduleEndType = {
  __typename: "ScheduleEndType",
  endAt?: string | null,
  maxOccurrences?: number | null,
  type: EndType,
};

export enum EndType {
  AFTER_OCCURRENCES = "AFTER_OCCURRENCES",
  NEVER = "NEVER",
  ON_DATE = "ON_DATE",
}


export enum QueryType {
  CUSTOM = "CUSTOM",
  SEGMENT = "SEGMENT",
  STANDARD = "STANDARD",
}


export type RecurrenceType = {
  __typename: "RecurrenceType",
  frequency: RecurrenceFrequency,
  interval: number,
  monthly?: MonthlyRecurrenceType | null,
  weekly?: WeeklyRecurrenceType | null,
};

export enum RecurrenceFrequency {
  DAILY = "DAILY",
  MONTHLY = "MONTHLY",
  WEEKLY = "WEEKLY",
}


export type MonthlyRecurrenceType = {
  __typename: "MonthlyRecurrenceType",
  dayOfMonth?: number | null,
  dayOfWeek?: DayOfWeek | null,
  mode: MonthlyMode,
  weekOfMonth?: WeekOfMonth | null,
};

export enum DayOfWeek {
  FRIDAY = "FRIDAY",
  MONDAY = "MONDAY",
  SATURDAY = "SATURDAY",
  SUNDAY = "SUNDAY",
  THURSDAY = "THURSDAY",
  TUESDAY = "TUESDAY",
  WEDNESDAY = "WEDNESDAY",
}


export enum MonthlyMode {
  DAY_OF_MONTH = "DAY_OF_MONTH",
  WEEKDAY_OF_MONTH = "WEEKDAY_OF_MONTH",
}


export enum WeekOfMonth {
  FIRST = "FIRST",
  FOURTH = "FOURTH",
  LAST = "LAST",
  SECOND = "SECOND",
  THIRD = "THIRD",
}


export type WeeklyRecurrenceType = {
  __typename: "WeeklyRecurrenceType",
  days: Array< DayOfWeek >,
};

export enum ScheduleType {
  ONE_TIME = "ONE_TIME",
  RECURRING = "RECURRING",
}


export type QueryRecordRequest = {
  executionId?: string | null,
  lastModifiedBy?: string | null,
  orgId?: string | null,
  query?: string | null,
  queryId?: string | null,
  validationStatus?: ValidationStatus | null,
};

export type ValidationMessageResponse = {
  __typename: "ValidationMessageResponse",
  message?: string | null,
  statusCode?: number | null,
  success?: boolean | null,
};

export type CreateQueryRecordInput = {
  createdBy: string,
  description?: string | null,
  executionId?: string | null,
  executionSource?: ExecutionSource | null,
  name: string,
  orgId: string,
  query: string,
  queryId?: string | null,
  queryType: QueryType,
  selectedFilterConfig?: string | null,
  status?: QueryStatus | null,
  templateId?: string | null,
  validationLogs?: string | null,
  validationStatus?: ValidationStatus | null,
};

export type CreateQueryRecordResponse = {
  __typename: "CreateQueryRecordResponse",
  athenaExecutionId?: string | null,
  createdAt?: string | null,
  createdBy?: string | null,
  description?: string | null,
  executionId: string,
  executionSource?: ExecutionSource | null,
  executionStatus?: ExecutionStatus | null,
  lastModifiedAt?: string | null,
  lastModifiedBy?: string | null,
  name: string,
  orgId: string,
  query: string,
  queryId: string,
  queryType: QueryType,
  status?: QueryStatus | null,
  templateId?: string | null,
  validationLogs?: string | null,
  validationStatus?: ValidationStatus | null,
};

export type CreateSchedulerRecordInput = {
  createdBy: string,
  end?: ScheduleEndInput | null,
  name: string,
  orgId: string,
  queryId: string,
  queryName: string,
  queryType: QueryType,
  recurrence?: RecurrenceInput | null,
  schedulerDescription?: string | null,
  startAt?: string | null,
  status?: SchedulerStatus | null,
  timezone: string,
  type: ScheduleType,
};

export type ScheduleEndInput = {
  endAt?: string | null,
  maxOccurrences?: number | null,
  type: EndType,
};

export type RecurrenceInput = {
  frequency: RecurrenceFrequency,
  interval: number,
  monthly?: MonthlyRecurrenceInput | null,
  weekly?: WeeklyRecurrenceInput | null,
};

export type MonthlyRecurrenceInput = {
  dayOfMonth?: number | null,
  dayOfWeek?: DayOfWeek | null,
  mode: MonthlyMode,
  weekOfMonth?: WeekOfMonth | null,
};

export type WeeklyRecurrenceInput = {
  days: Array< DayOfWeek >,
};

export type CreateSchedulerRecordResponse = {
  __typename: "CreateSchedulerRecordResponse",
  createdAt: string,
  createdBy: string,
  end?: ScheduleEndType | null,
  lastModifiedAt?: string | null,
  lastModifiedBy?: string | null,
  name: string,
  orgId: string,
  queryId: string,
  queryName: string,
  queryType: QueryType,
  recurrence?: RecurrenceType | null,
  schedulerDescription?: string | null,
  schedulerId: string,
  schedulerStatus?: SchedulerStatus | null,
  startAt?: string | null,
  timezone?: string | null,
  type?: ScheduleType | null,
};

export type SendEmailInput = {
  action: string,
  emailTemplateName?: string | null,
  payload?: string | null,
  recipients?: Array< string > | null,
};

export type SendEmailResponse = {
  __typename: "SendEmailResponse",
  body?: string | null,
  statusCode?: number | null,
};

export type SubmitQueryInput = {
  executionId?: string | null,
  lastModifiedBy?: string | null,
  orgId: string,
  queryId: string,
};

export type SubmitQueryResponse = {
  __typename: "SubmitQueryResponse",
  executionId: string,
  message: string,
  orgId: string,
  queryId: string,
  statusCode: number,
  success: boolean,
};

export type QueryResultResponse = {
  __typename: "QueryResultResponse",
  data?: QueryResultData | null,
  message?: string | null,
  statusCode?: number | null,
};

export type QueryResultData = {
  __typename: "QueryResultData",
  headers?: Array< string > | null,
  pagination?: PaginationInfo | null,
  rows?: string | null,
};

export type PaginationInfo = {
  __typename: "PaginationInfo",
  pageNumber?: number | null,
  pageSize?: number | null,
  totalRows?: number | null,
};

export type DashboardNameInfo = {
  __typename: "DashboardNameInfo",
  dashboardId: string,
  name?: string | null,
};

export type HealthResponse = {
  __typename: "HealthResponse",
  environment: string,
  status: string,
  timestamp: string,
  version: string,
};

export type GetMatchScheduleInput = {
  matchDate?: string | null,
  matchId?: string | null,
  year: number,
};

export type MatchScheduleType = {
  __typename: "MatchScheduleType",
  location?: string | null,
  market?: string | null,
  match_date?: string | null,
  match_id?: string | null,
  stadium?: string | null,
  status?: MatchScheduleStatus | null,
  team_1?: string | null,
  team_1_code?: string | null,
  team_2?: string | null,
  team_2_code?: string | null,
  year?: number | null,
};

export enum MatchScheduleStatus {
  CANCELLED = "CANCELLED",
  DELAYED = "DELAYED",
  ON_TIME = "ON_TIME",
  POSTPONED = "POSTPONED",
  SCHEDULED = "SCHEDULED",
}


export type MetadataType = {
  __typename: "MetadataType",
  metadata:  Array<Metadata >,
  source: string,
};

export type Metadata = {
  __typename: "Metadata",
  columns?:  Array<MetadataColumnsType > | null,
  database_name?: string | null,
  datasource_name?: string | null,
  table_description?: string | null,
  table_name?: string | null,
};

export type MetadataColumnsType = {
  __typename: "MetadataColumnsType",
  description?: string | null,
  name?: string | null,
  type?: string | null,
};

export type GetNotificationInput = {
  notificationId?: string | null,
  orgId: string,
  username?: string | null,
};

export type GetNotificationType = {
  __typename: "GetNotificationType",
  createdAt?: string | null,
  createdBy?: string | null,
  isRead?: boolean | null,
  notificationId?: string | null,
  orgId?: string | null,
  payload?: string | null,
  readAt?: string | null,
  username?: string | null,
};

export type PBDashboardQueryInput = {
  clubCode: string,
};

export type PBDashboardConfig = {
  __typename: "PBDashboardConfig",
  clubCode: string,
  createdAt?: string | null,
  embedUrl?: string | null,
  groupId: string,
  reportId: string,
};

export type PreSignedUrl = {
  bucketSuffix: string,
  contentType: string,
  s3keyName: string,
};

export type PreSignedUrlResponse = {
  __typename: "PreSignedUrlResponse",
  deleteUrl?: string | null,
  error?: string | null,
  getUrl?: string | null,
  putUrl?: string | null,
  statusCode?: number | null,
};

export type QueryHistoryInput = {
  pkName: string,
  pkValue: string,
  skName: string,
  skValue: string,
};

export type QueryExecutionRecord = {
  __typename: "QueryExecutionRecord",
  athenaExecutionId?: string | null,
  createdAt?: string | null,
  createdBy?: string | null,
  description?: string | null,
  executedAt?: string | null,
  executedBy?: string | null,
  executionId: string,
  lastModifiedAt?: string | null,
  lastModifiedBy?: string | null,
  name?: string | null,
  orgId: string,
  queryId?: string | null,
  queryType?: QueryType | null,
  schedulerName?: string | null,
  segmentedFanCount?: string | null,
  status?: QueryStatus | null,
};

export type QueryHistoryChartRecord = {
  __typename: "QueryHistoryChartRecord",
  athenaExecutionId?: string | null,
  createdBy?: string | null,
  executionId: string,
  executionStatus?: ExecutionStatus | null,
  lastModifiedAt?: string | null,
  metadata?: string | null,
  name?: string | null,
  orgId: string,
  queryId?: string | null,
};

export type QueryRecord = {
  __typename: "QueryRecord",
  createdAt?: string | null,
  createdBy?: string | null,
  description?: string | null,
  lastModifiedAt?: string | null,
  lastModifiedBy?: string | null,
  name?: string | null,
  orgId: string,
  query?: string | null,
  queryId: string,
  queryType?: QueryType | null,
  status?: QueryStatus | null,
};

export type QueryResultInput = {
  athenaExecutionId: string,
  executionId: string,
  maxRows?: number | null,
  orgId: string,
  pageNumber?: number | null,
  queryId: string,
  searchStr?: string | null,
};

export type QueryTemplate = {
  __typename: "QueryTemplate",
  createdAt?: string | null,
  createdBy?: string | null,
  description?: string | null,
  filters?:  Array<TemplateFilter > | null,
  lastModifiedAt?: string | null,
  lastModifiedBy?: string | null,
  name: string,
  orgId: string,
  query: string,
  templateId: string,
  templateType?: TemplateType | null,
};

export type TemplateFilter = {
  __typename: "TemplateFilter",
  dependent?: boolean | null,
  displayName?: string | null,
  name: string,
  parentFilterName?: string | null,
  values?: string | null,
};

export enum TemplateType {
  FAN_SEGMENT = "FAN_SEGMENT",
  STANDARD_QUERY = "STANDARD_QUERY",
}


export type QueryWithExecutionRecord = {
  __typename: "QueryWithExecutionRecord",
  athenaExecutionId?: string | null,
  createdAt?: string | null,
  createdBy?: string | null,
  executedAt?: string | null,
  executedBy?: string | null,
  executionDescription?: string | null,
  executionDuration?: string | null,
  executionId?: string | null,
  executionName?: string | null,
  executionSource?: ExecutionSource | null,
  executionStatus?: ExecutionStatus | null,
  lastModifiedAt?: string | null,
  lastModifiedBy?: string | null,
  metadata?: string | null,
  orgId?: string | null,
  query?: string | null,
  queryDescription?: string | null,
  queryId?: string | null,
  queryName?: string | null,
  schedulerId?: string | null,
  schedulerIds?: Array< string | null > | null,
  schedulerName?: string | null,
  segmentedFanCount?: string | null,
  selectedFilterConfig?: string | null,
  status?: QueryStatus | null,
  templateId?: string | null,
  validationLogs?: string | null,
  validationStatus?: ValidationStatus | null,
};

export type ResourceQueryInput = {
  orgId: string,
  section: Section,
};

export enum Section {
  COMMONFAQ = "COMMONFAQ",
  COMMONMANUAL = "COMMONMANUAL",
  COMMONREPORT = "COMMONREPORT",
  FAQ = "FAQ",
  MANUAL = "MANUAL",
  REPORT = "REPORT",
}


export type Resource = {
  __typename: "Resource",
  createdAt?: string | null,
  description?: string | null,
  fileSize?: string | null,
  fileUrl?: string | null,
  groupId?: string | null,
  groupName?: string | null,
  orgId: string,
  section: Section,
  title: string,
};

export type SchedulerNameInfo = {
  __typename: "SchedulerNameInfo",
  schedulerId: string,
  schedulerName?: string | null,
  status?: SchedulerStatus | null,
};

export type CreateChartsMutationVariables = {
  input: SaveChartInput,
};

export type CreateChartsMutation = {
  CreateCharts?:  {
    __typename: "ChartMetadata",
    athenaExecutionId?: string | null,
    chartId: string,
    chartImageUrl?: string | null,
    chartType: ChartType,
    config?: string | null,
    createdAt?: string | null,
    createdBy?: string | null,
    dashboardIds?: Array< string > | null,
    description?: string | null,
    executionId?: string | null,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    name?: string | null,
    orgId: string,
    queryId?: string | null,
  } | null,
};

export type CreateDashboardMutationVariables = {
  input: SaveDashboardInput,
};

export type CreateDashboardMutation = {
  CreateDashboard?:  {
    __typename: "DashboardMetadata",
    chartIds?: Array< string > | null,
    createdAt?: string | null,
    createdBy?: string | null,
    dashboardId: string,
    dashboardImageUrl?: string | null,
    description?: string | null,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    name?: string | null,
    orgId: string,
  } | null,
};

export type CreateNotificationMutationVariables = {
  input: CreateNotificationInput,
};

export type CreateNotificationMutation = {
  CreateNotification?:  {
    __typename: "Notification",
    createdAt: string,
    createdBy: string,
    isRead?: string | null,
    notificationId: string,
    orgId: string,
    payload?: string | null,
    readAt?: string | null,
    readBy?: string | null,
    username: string,
  } | null,
};

export type CreateQueryTemplateMutationVariables = {
  input: CreateQueryTemplateInput,
};

export type CreateQueryTemplateMutation = {
  CreateQueryTemplate:  {
    __typename: "CreateQueryTemplateResponse",
    created?:  Array< {
      __typename: "CreatedQueryTemplateReference",
      orgId: string,
      templateId: string,
    } > | null,
    error?: string | null,
    failed?:  Array< {
      __typename: "FailedQueryTemplateReference",
      orgId: string,
      reason: string,
    } > | null,
    message?: string | null,
    templateKey: string,
  },
};

export type CreateUserMutationVariables = {
  userRequest: CreateUserInput,
};

export type CreateUserMutation = {
  CreateUser:  {
    __typename: "UserResponse",
    message?: string | null,
    success?: boolean | null,
  },
};

export type DeleteChartOrDashboardMutationVariables = {
  input: DeleteChartOrDashboardInput,
};

export type DeleteChartOrDashboardMutation = {
  DeleteChartOrDashboard?:  {
    __typename: "DeleteResponse",
    message?: string | null,
    statusCode?: number | null,
  } | null,
};

export type DeleteHistoryMutationVariables = {
  input: DeleteHistoryInput,
};

export type DeleteHistoryMutation = {
  DeleteHistory?:  {
    __typename: "DeleteHistoryResponse",
    message?: string | null,
    statusCode?: number | null,
  } | null,
};

export type DeleteNotificationMutationVariables = {
  input: DeleteNotificationInput,
};

export type DeleteNotificationMutation = {
  DeleteNotification?:  {
    __typename: "DeleteNotificationResponse",
    message?: string | null,
    statusCode?: number | null,
  } | null,
};

export type DeleteScheduleMutationVariables = {
  input: DeleteScheduleInput,
};

export type DeleteScheduleMutation = {
  DeleteSchedule:  {
    __typename: "DeleteScheduleResponse",
    message?: string | null,
    schedulerId: string,
    success: boolean,
    successCode?: number | null,
  },
};

export type EditDashboardMutationVariables = {
  input: SaveDashboardInput,
};

export type EditDashboardMutation = {
  EditDashboard?:  {
    __typename: "DashboardMetadata",
    chartIds?: Array< string > | null,
    createdAt?: string | null,
    createdBy?: string | null,
    dashboardId: string,
    dashboardImageUrl?: string | null,
    description?: string | null,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    name?: string | null,
    orgId: string,
  } | null,
};

export type NotifyQueryValidationMutationVariables = {
  input: QueryValidationNotifyInput,
};

export type NotifyQueryValidationMutation = {
  NotifyQueryValidation:  {
    __typename: "QueryValidationRecord",
    athenaExecutionId?: string | null,
    createdAt?: string | null,
    createdBy?: string | null,
    executionDuration?: string | null,
    executionId?: string | null,
    executionSource?: ExecutionSource | null,
    executionStatus?: ExecutionStatus | null,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    orgId: string,
    query?: string | null,
    queryDescription?: string | null,
    queryId?: string | null,
    queryName?: string | null,
    segmentedFanCount?: string | null,
    status?: QueryStatus | null,
    validationLogs?: string | null,
    validationStatus?: ValidationStatus | null,
  },
};

export type UpdateScheduleStatusMutationVariables = {
  input: UpdateScheduleStatusInput,
};

export type UpdateScheduleStatusMutation = {
  UpdateScheduleStatus?:  {
    __typename: "QuerySchedulers",
    createdAt?: string | null,
    createdBy?: string | null,
    end?:  {
      __typename: "ScheduleEndType",
      endAt?: string | null,
      maxOccurrences?: number | null,
      type: EndType,
    } | null,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    name: string,
    orgId: string,
    queryId: string,
    queryName?: string | null,
    queryType?: QueryType | null,
    recurrence?:  {
      __typename: "RecurrenceType",
      frequency: RecurrenceFrequency,
      interval: number,
      monthly?:  {
        __typename: "MonthlyRecurrenceType",
        dayOfMonth?: number | null,
        dayOfWeek?: DayOfWeek | null,
        mode: MonthlyMode,
        weekOfMonth?: WeekOfMonth | null,
      } | null,
      weekly?:  {
        __typename: "WeeklyRecurrenceType",
        days: Array< DayOfWeek >,
      } | null,
    } | null,
    schedulerDescription?: string | null,
    schedulerId: string,
    schedulerStatus?: SchedulerStatus | null,
    startAt?: string | null,
    timezone?: string | null,
    type?: ScheduleType | null,
  } | null,
};

export type ValidateQueryRecordMutationVariables = {
  queryRecord: QueryRecordRequest,
};

export type ValidateQueryRecordMutation = {
  ValidateQueryRecord?:  {
    __typename: "ValidationMessageResponse",
    message?: string | null,
    statusCode?: number | null,
    success?: boolean | null,
  } | null,
};

export type CreateQueryRecordMutationVariables = {
  queryRecordInput: CreateQueryRecordInput,
};

export type CreateQueryRecordMutation = {
  createQueryRecord:  {
    __typename: "CreateQueryRecordResponse",
    athenaExecutionId?: string | null,
    createdAt?: string | null,
    createdBy?: string | null,
    description?: string | null,
    executionId: string,
    executionSource?: ExecutionSource | null,
    executionStatus?: ExecutionStatus | null,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    name: string,
    orgId: string,
    query: string,
    queryId: string,
    queryType: QueryType,
    status?: QueryStatus | null,
    templateId?: string | null,
    validationLogs?: string | null,
    validationStatus?: ValidationStatus | null,
  },
};

export type CreateSchedulerRecordMutationVariables = {
  schedulerRecordInput: CreateSchedulerRecordInput,
};

export type CreateSchedulerRecordMutation = {
  createSchedulerRecord:  {
    __typename: "CreateSchedulerRecordResponse",
    createdAt: string,
    createdBy: string,
    end?:  {
      __typename: "ScheduleEndType",
      endAt?: string | null,
      maxOccurrences?: number | null,
      type: EndType,
    } | null,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    name: string,
    orgId: string,
    queryId: string,
    queryName: string,
    queryType: QueryType,
    recurrence?:  {
      __typename: "RecurrenceType",
      frequency: RecurrenceFrequency,
      interval: number,
      monthly?:  {
        __typename: "MonthlyRecurrenceType",
        dayOfMonth?: number | null,
        dayOfWeek?: DayOfWeek | null,
        mode: MonthlyMode,
        weekOfMonth?: WeekOfMonth | null,
      } | null,
      weekly?:  {
        __typename: "WeeklyRecurrenceType",
        days: Array< DayOfWeek >,
      } | null,
    } | null,
    schedulerDescription?: string | null,
    schedulerId: string,
    schedulerStatus?: SchedulerStatus | null,
    startAt?: string | null,
    timezone?: string | null,
    type?: ScheduleType | null,
  },
};

export type SendEmailMutationVariables = {
  input: SendEmailInput,
};

export type SendEmailMutation = {
  sendEmail:  {
    __typename: "SendEmailResponse",
    body?: string | null,
    statusCode?: number | null,
  },
};

export type SubmitQueryMutationVariables = {
  input: SubmitQueryInput,
};

export type SubmitQueryMutation = {
  submitQuery:  {
    __typename: "SubmitQueryResponse",
    executionId: string,
    message: string,
    orgId: string,
    queryId: string,
    statusCode: number,
    success: boolean,
  },
};

export type GetAllocationsQueryVariables = {
  maxRows?: number | null,
  orgId: string,
  pageNumber?: number | null,
  searchStr?: string | null,
};

export type GetAllocationsQuery = {
  GetAllocations:  {
    __typename: "QueryResultResponse",
    data?:  {
      __typename: "QueryResultData",
      headers?: Array< string > | null,
      pagination?:  {
        __typename: "PaginationInfo",
        pageNumber?: number | null,
        pageSize?: number | null,
        totalRows?: number | null,
      } | null,
      rows?: string | null,
    } | null,
    message?: string | null,
    statusCode?: number | null,
  },
};

export type GetChartQueryVariables = {
  chartId: string,
  orgId: string,
};

export type GetChartQuery = {
  GetChart?:  {
    __typename: "ChartMetadata",
    athenaExecutionId?: string | null,
    chartId: string,
    chartImageUrl?: string | null,
    chartType: ChartType,
    config?: string | null,
    createdAt?: string | null,
    createdBy?: string | null,
    dashboardIds?: Array< string > | null,
    description?: string | null,
    executionId?: string | null,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    name?: string | null,
    orgId: string,
    queryId?: string | null,
  } | null,
};

export type GetChartsQueryVariables = {
  orgId: string,
};

export type GetChartsQuery = {
  GetCharts:  Array< {
    __typename: "ChartMetadata",
    athenaExecutionId?: string | null,
    chartId: string,
    chartImageUrl?: string | null,
    chartType: ChartType,
    config?: string | null,
    createdAt?: string | null,
    createdBy?: string | null,
    dashboardIds?: Array< string > | null,
    description?: string | null,
    executionId?: string | null,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    name?: string | null,
    orgId: string,
    queryId?: string | null,
  } >,
};

export type GetDashboardQueryVariables = {
  dashboardId: string,
  orgId: string,
};

export type GetDashboardQuery = {
  GetDashboard?:  {
    __typename: "DashboardMetadata",
    chartIds?: Array< string > | null,
    createdAt?: string | null,
    createdBy?: string | null,
    dashboardId: string,
    dashboardImageUrl?: string | null,
    description?: string | null,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    name?: string | null,
    orgId: string,
  } | null,
};

export type GetDashboardNamesQueryVariables = {
  dashboardIds: Array< string >,
  orgId: string,
};

export type GetDashboardNamesQuery = {
  GetDashboardNames?:  Array< {
    __typename: "DashboardNameInfo",
    dashboardId: string,
    name?: string | null,
  } | null > | null,
};

export type GetDashboardsQueryVariables = {
  orgId: string,
};

export type GetDashboardsQuery = {
  GetDashboards?:  Array< {
    __typename: "DashboardMetadata",
    chartIds?: Array< string > | null,
    createdAt?: string | null,
    createdBy?: string | null,
    dashboardId: string,
    dashboardImageUrl?: string | null,
    description?: string | null,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    name?: string | null,
    orgId: string,
  } | null > | null,
};

export type GetHealthQueryVariables = {
};

export type GetHealthQuery = {
  GetHealth:  {
    __typename: "HealthResponse",
    environment: string,
    status: string,
    timestamp: string,
    version: string,
  },
};

export type GetMatchScheduleQueryVariables = {
  input: GetMatchScheduleInput,
};

export type GetMatchScheduleQuery = {
  GetMatchSchedule?:  Array< {
    __typename: "MatchScheduleType",
    location?: string | null,
    market?: string | null,
    match_date?: string | null,
    match_id?: string | null,
    stadium?: string | null,
    status?: MatchScheduleStatus | null,
    team_1?: string | null,
    team_1_code?: string | null,
    team_2?: string | null,
    team_2_code?: string | null,
    year?: number | null,
  } | null > | null,
};

export type GetMetadataQueryVariables = {
  source: string,
};

export type GetMetadataQuery = {
  GetMetadata?:  {
    __typename: "MetadataType",
    metadata:  Array< {
      __typename: "Metadata",
      columns?:  Array< {
        __typename: "MetadataColumnsType",
        description?: string | null,
        name?: string | null,
        type?: string | null,
      } > | null,
      database_name?: string | null,
      datasource_name?: string | null,
      table_description?: string | null,
      table_name?: string | null,
    } >,
    source: string,
  } | null,
};

export type GetNotificationQueryVariables = {
  input: GetNotificationInput,
};

export type GetNotificationQuery = {
  GetNotification?:  Array< {
    __typename: "GetNotificationType",
    createdAt?: string | null,
    createdBy?: string | null,
    isRead?: boolean | null,
    notificationId?: string | null,
    orgId?: string | null,
    payload?: string | null,
    readAt?: string | null,
    username?: string | null,
  } | null > | null,
};

export type GetPBDashboardConfigQueryVariables = {
  input: PBDashboardQueryInput,
};

export type GetPBDashboardConfigQuery = {
  GetPBDashboardConfig?:  {
    __typename: "PBDashboardConfig",
    clubCode: string,
    createdAt?: string | null,
    embedUrl?: string | null,
    groupId: string,
    reportId: string,
  } | null,
};

export type GetPreSignedUrlQueryVariables = {
  input?: PreSignedUrl | null,
};

export type GetPreSignedUrlQuery = {
  GetPreSignedUrl?:  {
    __typename: "PreSignedUrlResponse",
    deleteUrl?: string | null,
    error?: string | null,
    getUrl?: string | null,
    putUrl?: string | null,
    statusCode?: number | null,
  } | null,
};

export type GetQueryHistoryQueryVariables = {
  input: QueryHistoryInput,
};

export type GetQueryHistoryQuery = {
  GetQueryHistory:  Array< {
    __typename: "QueryExecutionRecord",
    athenaExecutionId?: string | null,
    createdAt?: string | null,
    createdBy?: string | null,
    description?: string | null,
    executedAt?: string | null,
    executedBy?: string | null,
    executionId: string,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    name?: string | null,
    orgId: string,
    queryId?: string | null,
    queryType?: QueryType | null,
    schedulerName?: string | null,
    segmentedFanCount?: string | null,
    status?: QueryStatus | null,
  } >,
};

export type GetQueryHistoryForChartQueryVariables = {
  input: QueryHistoryInput,
};

export type GetQueryHistoryForChartQuery = {
  GetQueryHistoryForChart:  Array< {
    __typename: "QueryHistoryChartRecord",
    athenaExecutionId?: string | null,
    createdBy?: string | null,
    executionId: string,
    executionStatus?: ExecutionStatus | null,
    lastModifiedAt?: string | null,
    metadata?: string | null,
    name?: string | null,
    orgId: string,
    queryId?: string | null,
  } >,
};

export type GetQueryRecordsQueryVariables = {
  filterDropdownValue?: boolean | null,
  orgId: string,
};

export type GetQueryRecordsQuery = {
  GetQueryRecords:  Array< {
    __typename: "QueryRecord",
    createdAt?: string | null,
    createdBy?: string | null,
    description?: string | null,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    name?: string | null,
    orgId: string,
    query?: string | null,
    queryId: string,
    queryType?: QueryType | null,
    status?: QueryStatus | null,
  } >,
};

export type GetQueryResultQueryVariables = {
  input?: QueryResultInput | null,
};

export type GetQueryResultQuery = {
  GetQueryResult:  {
    __typename: "QueryResultResponse",
    data?:  {
      __typename: "QueryResultData",
      headers?: Array< string > | null,
      pagination?:  {
        __typename: "PaginationInfo",
        pageNumber?: number | null,
        pageSize?: number | null,
        totalRows?: number | null,
      } | null,
      rows?: string | null,
    } | null,
    message?: string | null,
    statusCode?: number | null,
  },
};

export type GetQuerySchedulersQueryVariables = {
  orgId: string,
};

export type GetQuerySchedulersQuery = {
  GetQuerySchedulers:  Array< {
    __typename: "QuerySchedulers",
    createdAt?: string | null,
    createdBy?: string | null,
    end?:  {
      __typename: "ScheduleEndType",
      endAt?: string | null,
      maxOccurrences?: number | null,
      type: EndType,
    } | null,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    name: string,
    orgId: string,
    queryId: string,
    queryName?: string | null,
    queryType?: QueryType | null,
    recurrence?:  {
      __typename: "RecurrenceType",
      frequency: RecurrenceFrequency,
      interval: number,
      monthly?:  {
        __typename: "MonthlyRecurrenceType",
        dayOfMonth?: number | null,
        dayOfWeek?: DayOfWeek | null,
        mode: MonthlyMode,
        weekOfMonth?: WeekOfMonth | null,
      } | null,
      weekly?:  {
        __typename: "WeeklyRecurrenceType",
        days: Array< DayOfWeek >,
      } | null,
    } | null,
    schedulerDescription?: string | null,
    schedulerId: string,
    schedulerStatus?: SchedulerStatus | null,
    startAt?: string | null,
    timezone?: string | null,
    type?: ScheduleType | null,
  } >,
};

export type GetQueryTemplatesQueryVariables = {
  orgId: string,
};

export type GetQueryTemplatesQuery = {
  GetQueryTemplates:  Array< {
    __typename: "QueryTemplate",
    createdAt?: string | null,
    createdBy?: string | null,
    description?: string | null,
    filters?:  Array< {
      __typename: "TemplateFilter",
      dependent?: boolean | null,
      displayName?: string | null,
      name: string,
      parentFilterName?: string | null,
      values?: string | null,
    } > | null,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    name: string,
    orgId: string,
    query: string,
    templateId: string,
    templateType?: TemplateType | null,
  } >,
};

export type GetQueryWithExecutionRecordsQueryVariables = {
  executionId: string,
  orgId: string,
  queryId: string,
};

export type GetQueryWithExecutionRecordsQuery = {
  GetQueryWithExecutionRecords?:  {
    __typename: "QueryWithExecutionRecord",
    athenaExecutionId?: string | null,
    createdAt?: string | null,
    createdBy?: string | null,
    executedAt?: string | null,
    executedBy?: string | null,
    executionDescription?: string | null,
    executionDuration?: string | null,
    executionId?: string | null,
    executionName?: string | null,
    executionSource?: ExecutionSource | null,
    executionStatus?: ExecutionStatus | null,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    metadata?: string | null,
    orgId?: string | null,
    query?: string | null,
    queryDescription?: string | null,
    queryId?: string | null,
    queryName?: string | null,
    schedulerId?: string | null,
    schedulerIds?: Array< string | null > | null,
    schedulerName?: string | null,
    segmentedFanCount?: string | null,
    selectedFilterConfig?: string | null,
    status?: QueryStatus | null,
    templateId?: string | null,
    validationLogs?: string | null,
    validationStatus?: ValidationStatus | null,
  } | null,
};

export type GetResourcesQueryVariables = {
  input: ResourceQueryInput,
};

export type GetResourcesQuery = {
  GetResources?:  Array< {
    __typename: "Resource",
    createdAt?: string | null,
    description?: string | null,
    fileSize?: string | null,
    fileUrl?: string | null,
    groupId?: string | null,
    groupName?: string | null,
    orgId: string,
    section: Section,
    title: string,
  } | null > | null,
};

export type GetSchedulerNamesQueryVariables = {
  orgId: string,
  schedulerIds: Array< string >,
};

export type GetSchedulerNamesQuery = {
  GetSchedulerNames?:  Array< {
    __typename: "SchedulerNameInfo",
    schedulerId: string,
    schedulerName?: string | null,
    status?: SchedulerStatus | null,
  } | null > | null,
};

export type OnCreateNotificationSubscriptionVariables = {
  username: string,
};

export type OnCreateNotificationSubscription = {
  onCreateNotification?:  {
    __typename: "Notification",
    createdAt: string,
    createdBy: string,
    isRead?: string | null,
    notificationId: string,
    orgId: string,
    payload?: string | null,
    readAt?: string | null,
    readBy?: string | null,
    username: string,
  } | null,
};

export type OnValidateQueryRecordsSubscriptionVariables = {
  orgId: string,
};

export type OnValidateQueryRecordsSubscription = {
  onValidateQueryRecords?:  {
    __typename: "QueryValidationRecord",
    athenaExecutionId?: string | null,
    createdAt?: string | null,
    createdBy?: string | null,
    executionDuration?: string | null,
    executionId?: string | null,
    executionSource?: ExecutionSource | null,
    executionStatus?: ExecutionStatus | null,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    orgId: string,
    query?: string | null,
    queryDescription?: string | null,
    queryId?: string | null,
    queryName?: string | null,
    segmentedFanCount?: string | null,
    status?: QueryStatus | null,
    validationLogs?: string | null,
    validationStatus?: ValidationStatus | null,
  } | null,
};
